export const ImportRowInstructionsNetflix = () => {
  return (
    <>
      <div className="_text-align--center _margin-bottom--1rem">
        <img src="/images/logos/netflix_logo.svg" style={{ height: "3rem" }} />
      </div>
      <p className="_margin-bottom--1rem">
        In order to import your Netflix history, you will need to download your
        data from Netflix.
      </p>
      <p className="_margin-bottom--1rem">
        Follow the steps below to download your Netflix viewing history:
      </p>
      <ol className="spaced_ordered_list _margin-left--1rem _list-style-type--auto">
        <li>
          Navigate to&nbsp;
          <a
            className="external_link"
            href="https://www.netflix.com/account/profiles"
          >
            https://www.netflix.com/account/profiles
          </a>
        </li>
        <li>Select your profile from the list</li>
        <li>Select &apos;Viewing Activity&apos;</li>
        <li>
          Scroll down to the bottom of the paginated list and click
          &apos;Download All&apos;
        </li>
        <li>
          This should download a file titled <b>NetflixViewingHistory.csv</b>
        </li>
        <li>Drag that file into the file upload area here.</li>
      </ol>
    </>
  );
};
